import { createRoot } from 'react-dom/client'

import WebsocketStatusControl from './WebsocketStatus/WebsocketStatus'

class WebsocketStatusMapControl {
  constructor() {
    this._container = null
  }

  onAdd() {
    this._container = document.createElement('div')
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-websocket-status'
    this._root = createRoot(this._container)
    this._root.render(<WebsocketStatusControl />)
    return this._container
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount()
      })
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container)
    }
  }
}

export default WebsocketStatusMapControl
